// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f_Rq","col":"styles_col__WI3WF"};